<template>
    <vs-input-number
      :min="min"
      :step="step"
      v-model="ActionScore"
      @input="setVal"
    />
</template>

<script>
export default {
  name: 'CellScore',
  data() {
    return {
      min:1,
      step:1,
      ActionScore: 1,
    }
  },
  created(){
    this.ActionScore  = Number(this.params.value)
  },
  methods:{
    setVal(){
      this.params.setValue(Number(this.ActionScore))
    }
  },
}
</script>